
import React, { Component } from 'react';
import Moment from 'moment';
import axios from "axios";

const removeNullFromArray = (arrayToClean) => {
    const cleanedArray = [];
    arrayToClean.forEach((val) => {
      if(val !== null){
        cleanedArray.push(val);
      }
    });
  
    return cleanedArray;
  }  

class DeleteFile extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            ...this.props,    
            loading: false,      
           
          
         
        }
        this.onSubmit = this.onSubmit.bind(this)
        this.onChange = this.onChange.bind(this)
        //this.onChangeImageHandler = this.onChangeImageHandler.bind(this)
       // this.onChangeImageHandler1 = this.onChangeImageHandler1.bind(this)
       
    }



    onChange = e => this.setState({ [e.target.name]: e.target.value });
    //onChangeImageHandler1 = e => this.setState({ file1: e.target.files[0] });


    onSubmit = (e) => {
        e.preventDefault();
        this.setState({ loading: true });
        delete this.state.responseData.files[this.state.d]
        this.state.responseData.files=removeNullFromArray(this.state.responseData.files)
        this.state.responseData.nid=this.state.nid
        //axios.post('https://fs3.acl.gov/UpdateNADRCFile', this.state.responseData);
       axios.post('https://fs3.acl.gov/UpdateNADRCFile', this.state.responseData); 
        
         setTimeout(function () {
           e.preventDefault();
           window.location.reload();
       }, 3000) 
     

    };







    render() {

        console.log("passss:", this.props.nid)
        const { loading } = this.state;

        return (

            <div>
                    <div class="row body_content">

                        <div class="row" style={{ width: 100 + "%" }}>
                            <div class="post-content" style={{ width: 90 + "%" }}>
                                <p>Are you sure you want permanently remove this item?</p>

                                <form onSubmit={this.onSubmit}
                                
                                >
                                    <div grid grid-cols-6 gap-6>                                      
                                        <div class="flex flex-wrap -mx-3 mb-6" style={{ display: "none" }}>
                                            <div class="w-full px-3">
                                                <label
                                                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                                    for="grid-first-name"
                                                >
                                                    Resource Title
                                              </label>
                                                <input
                                                    class="appearance-none block w-full bg-gray-200 text-gray-700 border  border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                                    type="text"
                                                    name="title"
                                                    id="title"
                                                    //onChange={this.onChange}
                                                    aria-describedby="title"
                                                    placeholder="Enter Title"
                                                    value={this.state.title}
                                                />
                                            </div>
                                        </div>         
                                        <div class="form-group col-span-4" style={{ display: "none" }}>
                                            <label for="nid">Current Date</label>
                                            <input type="text" name="created" class="form-control" id="created" onChange={this.onChange}
                                                aria-describedby="created" value={Moment(this.state.currentDate).format("yyyy-MM-DDTHH:mm:ss")} style={{ width: 50 + "%" }} />
                                        </div>
                                        
                                        <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                                          

                                       <button
                                            disabled={loading}
                                            type="submit"
                                            className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                        >
                                            {loading && (
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />
                                            )}
                                            {loading && <span>Processing Request</span>}
                                            {!loading && <span>Delete</span>}

                                        </button>
                                        </div>

                                    </div>
                                </form>



                            </div>

                        </div>









                    </div >
             
            </div>

        );
    }
}



export default DeleteFile;

